module.exports = __webpack_public_path__ + "img/feiyong.9350877f.png";